"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _formatDate = _interopRequireDefault(require("./formatDate"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

// ISODate
// @link: https://en.wikipedia.org/wiki/ISO_8601
// YYYY-MM-DDThh:mm:ss.sssZ :: "2017-08-16T19:49:50.940Z"
// YYYY-MM-DD               :: "2017-08-16"
var toLocalizedString = function toLocalizedString(locale) {
  return function (isoDate) {
    return (0, _formatDate["default"])(locale, 'L', isoDate);
  };
};

var _default = toLocalizedString;
exports["default"] = _default;